module.exports = __webpack_public_path__ + "img/Feature6-0.298dcb87.png";